import { createContext, useContext, useState, type ReactNode } from "react";

type PortalFiltersSheetContextValue = {
  filtersOpen: boolean;
  setFiltersOpen: (open: boolean) => void;
};

const PortalFiltersSheetContext = createContext<PortalFiltersSheetContextValue | null>(null);

export function PortalFiltersSheetProvider({ children }: { children: ReactNode }) {
  const [filtersOpen, setFiltersOpen] = useState(false);

  return (
    <PortalFiltersSheetContext.Provider value={{ filtersOpen, setFiltersOpen }}>
      {children}
    </PortalFiltersSheetContext.Provider>
  );
}

export function usePortalFiltersSheet(): PortalFiltersSheetContextValue {
  const fallback = useState(false);
  const context = useContext(PortalFiltersSheetContext);

  return context ?? { filtersOpen: fallback[0], setFiltersOpen: fallback[1] };
}